import { UserInterface } from "types/userTypes";
import { createMockListPage } from "./listingMocks";
import {
  DEMO_ACADEMY_NORTH_ID,
  DEMO_ACADEMY_SOUTH_ID,
  matchesAcademyIds,
} from "./mockFilterHelpers";
import { DEMO_ACADEMY_ID } from "./mockPlayers";
import { demoApi } from "./demoLocale";

export const mockUsers: UserInterface[] = [
  {
    UserId: "00000000-0000-0000-0000-000000000001",
    FirstName: "Demo",
    LastName: "Użytkownik",
    Email: "demo@academiq.pl",
    PhoneNumber: "600100200",
    Position: "Administrator",
    UserName: "demo@academiq.pl",
    Academy: { AcademyId: DEMO_ACADEMY_ID, Name: "Klub piłkarski" },
    IsActivate: true,
    Id: "00000000-0000-0000-0000-000000000901",
    ProfileId: "00000000-0000-0000-0000-000000000902",
    Nickname: "demo",
    Permissions: [
      {
        IsAvailable: true,
        PermissionDomainName: "Academy",
        PermissionFlagName: "Admin",
        PermissionFlagValue: -1,
        Id: "-1",
      },
    ],
    NotificationsType: [
      { Name: "Wiadomości", NotificationType: 0 },
      { Name: "Zajęcia", NotificationType: 1 },
    ],
  },
  {
    UserId: "00000000-0000-0000-0000-000000000002",
    FirstName: "Anna",
    LastName: "Kowalska",
    Email: "anna.kowalska@demo.pl",
    PhoneNumber: "600200300",
    Position: "Trener",
    UserName: "anna.kowalska@demo.pl",
    Academy: { AcademyId: DEMO_ACADEMY_ID, Name: "Klub piłkarski" },
    IsActivate: true,
    Id: "00000000-0000-0000-0000-000000000903",
    ProfileId: "00000000-0000-0000-0000-000000000904",
    Nickname: "anna.k",
    Permissions: [
      {
        IsAvailable: true,
        PermissionDomainName: "Players",
        PermissionFlagName: "View",
        PermissionFlagValue: 133,
        Id: "133",
      },
      {
        IsAvailable: true,
        PermissionDomainName: "Structure",
        PermissionFlagName: "View",
        PermissionFlagValue: 139,
        Id: "139",
      },
    ],
    NotificationsType: [{ Name: "Zajęcia", NotificationType: 1 }],
  },
  {
    UserId: "00000000-0000-0000-0000-000000000003",
    FirstName: "Piotr",
    LastName: "Nowak",
    Email: "piotr.nowak@demo.pl",
    PhoneNumber: "600300400",
    Position: "Koordynator",
    UserName: "piotr.nowak@demo.pl",
    Academy: {
      AcademyId: DEMO_ACADEMY_NORTH_ID,
      Name: "Oddział Akademii",
    },
    IsActivate: true,
    Id: "00000000-0000-0000-0000-000000000905",
    ProfileId: "00000000-0000-0000-0000-000000000906",
    Nickname: "piotr.n",
    Permissions: [
      {
        IsAvailable: true,
        PermissionDomainName: "Events",
        PermissionFlagName: "View",
        PermissionFlagValue: 67,
        Id: "67",
      },
    ],
    NotificationsType: [],
  },
  {
    UserId: "00000000-0000-0000-0000-000000000004",
    FirstName: "Ewa",
    LastName: "Lis",
    Email: "ewa.lis@demo.pl",
    PhoneNumber: "600400500",
    Position: "Recepcja",
    UserName: "ewa.lis@demo.pl",
    Academy: {
      AcademyId: DEMO_ACADEMY_SOUTH_ID,
      Name: "Oddział Akademii - Zachodni",
    },
    IsActivate: true,
    Id: "00000000-0000-0000-0000-000000000907",
    ProfileId: "00000000-0000-0000-0000-000000000908",
    Nickname: "ewa.l",
    Permissions: [],
    NotificationsType: [],
  },
];

export type MockUserDetail = UserInterface & {
  Contact: {
    Email: string;
    PhoneNumber: string;
  };
  Type: number;
};

const toUserDetail = (user: UserInterface): MockUserDetail => ({
  ...user,
  Contact: {
    Email: user.Email,
    PhoneNumber: user.PhoneNumber,
  },
  Type: user.Position === "Administrator" ? 0 : 1,
});

const userDetailsById: Record<string, MockUserDetail> = Object.fromEntries(
  mockUsers.map((user) => [user.UserId, toUserDetail(user)])
);

export const getMockUsersPage = demoApi((pageInfo: any) =>
  createMockListPage(mockUsers, pageInfo, {
    search: (user, search) =>
      `${user.FirstName} ${user.LastName}`.toLowerCase().includes(search) ||
      user.Email.toLowerCase().includes(search) ||
      user.Position.toLowerCase().includes(search),
    filters: [(user, info) => matchesAcademyIds(user.Academy?.AcademyId, info)],
  }));

export const getMockUserDetail = demoApi(async (userId?: string) => ({
  Data: userDetailsById[userId ?? ""] ?? userDetailsById[mockUsers[0].UserId],
}));

export const mockUserMutationSuccess = async (..._args: any[]) => ({ Success: true });
